(() => {
  function init(root) {
    if (root.dataset.cpReady) return;
    root.dataset.cpReady = 'true';
    root.querySelectorAll('[data-cp-category-link]').forEach(link => {
      link.addEventListener('click', () => {
        const select = root.querySelector('[data-cp-category]');
        if (select) select.value = link.dataset.cpCategoryLink;
      });
    });
    const filters = [...root.querySelectorAll('[data-cp-filter]')];
    const cards = [...root.querySelectorAll('[data-cp-article]')];
    filters.forEach(button => {
      button.addEventListener('click', () => {
        filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let shown = 0;
        cards.forEach(card => {
          const visible = button.dataset.cpFilter === 'all' || card.dataset.cpCategory === button.dataset.cpFilter;
          card.hidden = !visible;
          if (visible) shown++;
        });
        root.querySelectorAll('[data-cp-recent]').forEach(item => {
          item.hidden = button.dataset.cpFilter !== 'all' && item.dataset.cpCategory !== button.dataset.cpFilter;
        });
        const empty = root.querySelector('[data-cp-empty]');
        if (empty) empty.hidden = shown !== 0;
      });
    });
  }
  const scan = () => document.querySelectorAll('[data-cp-page]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
